import { render } from "./Text1.vue?vue&type=template&id=79586dc0&scoped=true"
import script from "./Text1.vue?vue&type=script&lang=js"
export * from "./Text1.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-79586dc0"

export default script